import { AxiosResponse } from 'axios';

import { axiosIntance } from '../../../config/ApiConfig';
import { PrintingService } from '../../../types/printingService/PrintingService';
import {
  PrinterServerConfigurationDTO,
  Setting,
} from '../../../types/settings/Setting';
import { PrintingServiceFormValues } from 'src/types/printingService/interfaces';

export const PrintingServiceRepository = {
  createPrintingService: (
    data: PrintingServiceFormValues
  ): Promise<AxiosResponse<PrintingService>> => {
    return axiosIntance.post('/accountSettingsPrinter', data);
  },

  updatePrintingService: (
    data: PrintingServiceFormValues
  ): Promise<AxiosResponse<PrintingService>> => {
    return axiosIntance.put('/accountSettingsPrinter', data);
  },

  deletePrintingService: (
    id: string,
    accountId: string
  ): Promise<AxiosResponse<{ sucess: boolean }>> => {
    return axiosIntance.delete(`/accountSettingsPrinter`, {
      data: { id, accountId },
    });
  },
  savePrintServerSettings: (
    serverData: PrinterServerConfigurationDTO
  ): Promise<AxiosResponse<Setting>> => {
    return axiosIntance.post(`/settings/print-server-settings`, serverData);
  },
  deletePrintServerSettings: (
    accountId: string
  ): Promise<AxiosResponse<Setting>> => {
    return axiosIntance.post(`/settings/print-server-settings/delete`, {
      account: accountId,
    });
  },
};
